export default __webpack_public_path__ + "static/media/weightlossregime_3@3x.a0606141.jpg";